/** Pure aggregation of the prologue timelines (no registry, safe for Node unit tests). */
import type { TimelineData } from '@/core/types/contracts';
import { HARBOR_TIMELINES } from './harbor';
import { STAGE_TIMELINES } from './stages';

export { sectionTimelineId, PLAY_TIMELINE_FX, HARBOR_POS } from './harbor';
export { battleMark } from './stages';

export const PROLOGUE_TIMELINES: TimelineData[] = [...HARBOR_TIMELINES, ...STAGE_TIMELINES];

export function findPrologueTimeline(id: string): TimelineData | undefined {
  return PROLOGUE_TIMELINES.find((t) => t.id === id);
}
